module.exports = __webpack_public_path__ + "img/project4_10.jpg.f5bd3e15.webp";